import styled from 'styled-components'

export const Audio = styled.audio`
  display: block;
  width: 100%;
  margin-top: 16px;
  margin-bottom: 16px;
`
